'use client';

import Link from 'next/link';

import { usePermission } from '@/lib/contexts/PermissionContext';
import { clearSessionAndRedirect } from '@/lib/utils/session';

/** LPのフッター */
export function SiteFooter() {
  const { isDemo } = usePermission();

  // デモログイン中は token Cookie が残り middleware が /login を弾くため、
  // 先にデモセッションを破棄してから遷移する。
  const handleLoginNav = (event: React.MouseEvent) => {
    if (isDemo) {
      event.preventDefault();
      void clearSessionAndRedirect('/login');
    }
  };

  return (
    <footer className="border-t border-blue-100 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-8 text-sm text-blue-800/70 md:flex-row md:px-6">
        <span className="hidden md:block md:flex-1" aria-hidden="true" />
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          <Link href="/terms" className="hover:text-blue-700">
            利用規約
          </Link>
          <Link href="/privacy" className="hover:text-blue-700">
            プライバシーポリシー
          </Link>
          <Link href="/legal/tokushoho" className="hover:text-blue-700">
            特定商取引法に基づく表記
          </Link>
          <Link href="/login" className="hover:text-blue-700" onClick={handleLoginNav}>
            ログイン
          </Link>
        </nav>
        <span className="md:flex-1 md:text-right">© {new Date().getFullYear()} tes-navi</span>
      </div>
    </footer>
  );
}
